import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const featuredProductsDefaultBlocks: BlockNode[] = [
  {
    id: 'featured-products-heading',
    type: 'text',
    content: { type: 'text', value: 'Featured Products', fontSize: 28, fontWeight: 700, textAlign: 'left' },
    layout: { order: 0, widthPct: 100 },
  },
  {
    id: 'featured-products-subheading',
    type: 'text',
    content: { type: 'text', value: 'Our top picks', fontSize: 16, fontWeight: 400, textAlign: 'left' },
    layout: { order: 1, widthPct: 100 },
  },
];

export const featuredProductsWidget = defineWidget({
  type: 'featured-products',
  schema: {
    label: 'Featured Products',
    description: 'Curated product showcase with highlighted hero items',
    props: {
      limit: {
        type: 'number',
        label: 'Number of products',
        min: 1,
        max: 50,
        default: 8,
        structural: true,
      },
      showHeaderLink: {
        type: 'boolean',
        label: 'Show Header Link',
        default: false,
      },
      headerLinkIcon: {
        type: 'icon',
        label: 'Header Link Icon',
        default: 'chevron-right',
      },
      headerLinkUrl: {
        type: 'link',
        label: 'Header Link URL',
      },
    },
    slots: {
      heading: { type: 'text', label: 'Section Heading' },
      subheading: { type: 'text', label: 'Section Subheading' },
      headerLinkText: { type: 'text', label: 'Header Link Text' },
    },
    dataDeps: ['featuredProducts'],
  },
  nameTh: 'สินค้าแนะนำ',
  descriptionTh: 'แสดงสินค้าแนะนำพร้อมไฮไลต์',
  category: 'products',
  thumbnail: '/widget-thumbnails/featured-products.svg',
  defaults: {
    type: 'featured-products',
    props: { limit: 8 },
    slots: {
      heading: { value: 'Featured Products' },
    },
  },
  defaultBlocks: featuredProductsDefaultBlocks,
});
